import React from 'react';
import ShearModeIcon from '@mui/icons-material/AspectRatio';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Divider } from '@mui/material';

import { hasCanUsePlatesPermission, isLoggedInUserRoot } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../monitor';
import { deleteAllPlatePairs } from '../../../../store/actions/deletionActions';
import { generatePlates } from '../../../../store/actions/paragonProcessActions';
import { cycleShearLineView } from '../../../../store/actions/visualOptionActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';
import { ToggleLockingMenuItem } from '../shared-menu-items/ToggleLockingMenuItem';

export function PlatePairsContainerMenu() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const isRoot = useAppSelector(isLoggedInUserRoot);
  const canUsePlates = useAppSelector(hasCanUsePlatesPermission);
  const componentDesign = useAppSelector(getActiveComponentDesign);

  if (!canUsePlates) return null;

  return (
    <SceneMenuContent>
      <AddItemMenuItem type="platePair" />

      {isRoot && (
        <SceneMenuItem
          icon={<RefreshIcon />}
          text="Regenerate Plates"
          disabled={componentDesign == null}
          onClick={() => {
            dispatch(generatePlates(componentDesign!));
            monitor.recordInteraction('Regenerate Plates menu item clicked');
          }}
        />
      )}

      <Divider />

      <SceneMenuItem
        icon={<ShearModeIcon />}
        text="Toggle Shear Lines"
        onClick={() => {
          dispatch(cycleShearLineView());
          monitor.recordInteraction('Toggle Shear Lines menu item clicked');
        }}
      />

      <Divider />
      <ToggleLockingMenuItem type="platePair" context="container" />

      <Divider />
      <SceneMenuItem
        icon={<DeleteIcon />}
        text="Delete All Plate Pairs"
        onClick={() => {
          dispatch(deleteAllPlatePairs());
          monitor.recordInteraction('Delete All Plate Pairs menu item clicked');
        }}
      />
    </SceneMenuContent>
  );
}
